<template>
    <div>
        <div class="row mb-2">
            <span class="col-12 font-weight-bold font-small-5">Biaya atau Beban <span class="text-danger">*</span></span>
            <div class="col-12 mt-50">
                <validation-provider #default="{ errors }" name="Biaya atau Beban" rules="required">
                    <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                        <b-form-radio v-model="formDatas.biaya_beban" value="biaya-perolehan">
                            Biaya Perolehan
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.biaya_beban" value="biaya-setelah-perolehan">
                            Biaya Setelah Perolehan
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.biaya_beban" value="beban">
                            Beban
                        </b-form-radio>
                    </div>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
        </div>
        <div class="row mb-2" v-if="['biaya-perolehan', 'biaya-setelah-perolehan'].includes(formDatas.biaya_beban)">
            <span class="col-12 font-weight-bold font-small-5">Keberadaan Aset Induk <span
                    class="text-danger">*</span></span>
            <div class="col-12 mt-50">
                <validation-provider #default="{ errors }" name="Keberadaan Aset Induk" rules="required">
                    <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                        <b-form-radio v-model="formDatas.is_aset_induk" value="tidak">
                            Tidak Diketahui Aset Induknya
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.is_aset_induk" value="iya">
                            Diketahui Aset Induknya
                        </b-form-radio>
                    </div>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
        </div>
        <div class="row mb-2" v-else-if="['beban'].includes(formDatas.biaya_beban)">
            <span class="col-12 font-weight-bold font-small-5">Jenis Beban <span class="text-danger">*</span></span>
            <div class="col-12 mt-50">
                <validation-provider #default="{ errors }" name="Jenis Beban" rules="required">
                    <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                        <b-form-radio v-model="formDatas.jenis_beban" value="persediaan">
                            Beban Persediaan
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.jenis_beban" value="beban-lainnya">
                            Beban Lainnya
                        </b-form-radio>
                    </div>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
        </div>
        <div class="row mb-2" v-if="['beban'].includes(formDatas.biaya_beban) || formDatas.is_aset_induk == 'tidak'">
            <span class="col-12 font-weight-bold font-small-5">Keterangan Biaya/Beban <span
                    class="text-danger">*</span></span>
            <div class="col-12 mt-50">
                <validation-provider #default="{ errors }" name="Keterangan Biaya/Beban" rules="required|min:140">
                    <b-form-textarea id="textarea-state" v-model="formDatas.kronologis_biaya_beban"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Isi Keterangan Biaya/Beban, minimal 140 Karakter" rows="3" />
                    <small class="textarea-counter-value float-right"
                        :class="formDatas.kronologis_biaya_beban.length < minChar ? 'bg-danger' : ''">
                        <span class="char-count">minimal karakter: {{ formDatas.kronologis_biaya_beban.length }}</span> / {{
                            minChar }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
        </div>
        <template
            v-if="['biaya-perolehan', 'biaya-setelah-perolehan'].includes(formDatas.biaya_beban) && formDatas.is_aset_induk == 'iya'">
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5">Nama PD/UKPD/UPB Aset Induk <span
                        class="text-danger">*</span></span>
                <div class="col-12 mt-50">
                    <validation-provider #default="{ errors }" name="PD/UKPD/UPB" rules="required">
                        <b-overlay :show="isLoadDataKolok" variant="light" opacity="0.85" blur="2px" rounded="sm">
                            <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                                <v-select id="kolokFilter" v-model="fSelect.kolok_aset_induk" label="text"
                                    :options="dsKolok" @input="setValKolokAsetInduk" />
                            </div>
                        </b-overlay>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </div>
            </div>
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5">KIB Aset Induk <span class="text-danger">*</span></span>
                <div class="col-12 mt-50">
                    <validation-provider #default="{ errors }" name="KIB" rules="required">
                        <b-overlay :show="isLoadDataKib" variant="light" opacity="0.85" blur="2px" rounded="sm">
                            <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                                <v-select id="kolokFilter" v-model="fSelect.kib_aset_induk" label="text" :options="dsKib"
                                    @input="setValKibAsetInduk" />
                            </div>
                        </b-overlay>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </div>
            </div>
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5">Kode Barang Aset Induk <span
                        class="text-danger">*</span></span>
                <div class="col-12 mt-50">
                    <validation-provider #default="{ errors }" name="Kode Barang" rules="required">
                        <b-overlay :show="isLoadDataKobar" variant="light" opacity="0.85" blur="2px" rounded="sm">
                            <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                                <v-select id="kolokFilter" v-model="fSelect.kobar_aset_induk" label="text"
                                    :options="dsKobar" @input="setValKobarAsetInduk" />
                            </div>
                        </b-overlay>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </div>
            </div>
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5">Nomor Register Aset Induk <span
                        class="text-danger">*</span></span>
                <div class="col-12 mt-50">
                    <validation-provider #default="{ errors }" name="Nomor Register" rules="required">
                        <b-overlay :show="isLoadDataNoreg" variant="light" opacity="0.85" blur="2px" rounded="sm">
                            <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                                <v-select id="kolokFilter" v-model="fSelect.noreg_aset_induk" label="text"
                                    :options="dsNoreg" @input="setValNoregAsetInduk" />
                            </div>
                        </b-overlay>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </div>
            </div>
        </template>
    </div>
</template>
  
<script>
import { ref, watch, watchEffect, onMounted } from '@vue/composition-api'
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required, min } from '@validations'
import Cleave from 'vue-cleave-component'
import Ripple from 'vue-ripple-directive'
import masterBRef from "@/composables/master/masterBRef";
import { showNotifikasi } from '@/libs/helper';
import { VueGoodTable } from "vue-good-table";
import { parserValue } from '@/libs/helper'
import moment from 'moment';
import { BFormTextarea } from 'bootstrap-vue'

export default {
    props: {
        fD: {
            type: Object,
            required: true,
        },
        bmd: {
            type: Object,
            required: true,
        },
        disabled: { type: Boolean, default: false },
        updateItem: Function,
    },
    setup(props, context) {
        const g = context.root;
        const formDatas = ref(props.fD);
        formDatas.value.kronologis_biaya_beban = props.fD.kronologis_biaya_beban || '';

        const minChar = 140;
        const year = moment().format('YYYY');
        const isLoadDataKolok = ref(false)
        const isLoadDataKib = ref(false)
        const isLoadDataKobar = ref(false)
        const isLoadDataNoreg = ref(false)

        /* Dataset */
        // Harus Didefine dulu satu satu
        const fSelect = ref({
            kolok_aset_induk: null,
            kib_aset_induk: null,
            kobar_aset_induk: null,
            noreg_aset_induk: null
        });
        const dsKolok = ref([]);
        const getDsKolok = (searchKolok = "") => {
            isLoadDataKolok.value = true;
            dsKolok.value = [];
            let params = {
                tahun: year,
                wilayah: null,
                cari: searchKolok,
            };
            masterBRef.getKolokDs(g, params).then(res => {
                if (res.success) {
                    dsKolok.value = res.rows;
                }
                isLoadDataKolok.value = false;
            }).catch(err => {
                isLoadDataKolok.value = true;
                console.log(err)
            });

        };
        const dsKib = ref([]);
        const getDsKib = (searchKolok = "") => {
            isLoadDataKib.value = true;
            dsKib.value = [];
            masterBRef.getKib(g, null).then(res => {
                if (res.success) {
                    dsKib.value = res.rows;
                }
                isLoadDataKib.value = false;
            }).catch(err => {
                isLoadDataKib.value = false;
                console.log(err)
            });

        };
        const dsKobar = ref([]);
        const getDsKobar = (searchKolok = "") => {
            isLoadDataKobar.value = true;
            dsKobar.value = [];
            let payload = {
                kolok: formDatas.value.kolok_aset_induk,
                kib: formDatas.value.kib_aset_induk
            };
            masterBRef.getKobar(g, payload).then(res => {
                if (res.success) {
                    dsKobar.value = res.rows;
                }
                isLoadDataKobar.value = false;
            }).catch(err => {
                isLoadDataKobar.value = false;
                console.log(err)
            });
        };
        const dsNoreg = ref([]);
        const getDsNoreg = () => {
            isLoadDataNoreg.value = true;
            dsNoreg.value = [];
            let payload = {
                kolok: formDatas.value.kolok_aset_induk,
                kib: formDatas.value.kib_aset_induk,
                kobar: formDatas.value.kobar_aset_induk,
                not_in_guid_aset: props.bmd.guid_aset,
            };
            masterBRef.getNoreg(g, payload).then(res => {
                if (res.success) {
                    dsNoreg.value = res.rows;
                }
                isLoadDataNoreg.value = false;
            }).catch(err => {
                isLoadDataNoreg.value = false;
                console.log(err)
            });

        };
        watchEffect(() => {
            fSelect.value.kolok_aset_induk = dsKolok.value.find(item => item.value == props.fD.kolok_aset_induk)
            fSelect.value.kib_aset_induk = dsKib.value.find(item => item.value == props.fD.kib_aset_induk)
            fSelect.value.kobar_aset_induk = dsKobar.value.find(item => item.value == props.fD.kobar_aset_induk)
            fSelect.value.noreg_aset_induk = dsNoreg.value.find(item => item.value == props.fD.noreg_aset_induk)
        })

        onMounted(() => {
            getDsKolok();
            getDsKib();
            if (formDatas.value.kib_aset_induk != null) {
                getDsKobar();
            }
            if (formDatas.value.kolok_aset_induk != null && formDatas.value.kib_aset_induk != null && formDatas.value.kobar_aset_induk != null) {
                getDsNoreg();
            }

        })

        const kolokFilterRef = ref();
        const setValKolokAsetInduk = () => {
            formDatas.value.kolok_aset_induk = fSelect.value.kolok_aset_induk.value;
            /* reset value dibawahnya */
            formDatas.value.kib_aset_induk = null;
            formDatas.value.kobar_aset_induk = null;
            formDatas.value.noreg_aset_induk = null;
        }
        const setValKibAsetInduk = () => {
            formDatas.value.kib_aset_induk = fSelect.value.kib_aset_induk.value;
            if (formDatas.value.kib_aset_induk != null) {
                getDsKobar();
            }
            /* reset value dibawahnya */
            formDatas.value.kobar_aset_induk = null;
            formDatas.value.noreg_aset_induk = null;
        }
        const setValKobarAsetInduk = () => {
            formDatas.value.kobar_aset_induk = fSelect.value.kobar_aset_induk.value;
            if (formDatas.value.kolok_aset_induk != null && formDatas.value.kib_aset_induk != null && formDatas.value.kobar_aset_induk != null) {
                getDsNoreg();
            }
            /* reset value dibawahnya */
            formDatas.value.noreg_aset_induk = null;
        }
        const setValNoregAsetInduk = () => {
            formDatas.value.noreg_aset_induk = fSelect.value.noreg_aset_induk.value;
        }
        return {
            isLoadDataKolok,
            isLoadDataKib,
            isLoadDataKobar,
            isLoadDataNoreg,
            minChar,

            formDatas,
            fSelect,

            dsKolok,
            dsKib,
            dsKobar,
            dsNoreg,
            setValKolokAsetInduk,
            setValKibAsetInduk,
            setValKobarAsetInduk,
            setValNoregAsetInduk,
            kolokFilterRef
        }
    },
    computed: {
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        VueGoodTable,
        vSelect,
        BFormTextarea
    },
    directives: {
        Ripple,
    },
    methods: {
    },
    data() {
        return {
            required,
            min
        }
    },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>